
import { apiSlice } from "./apiSlice";

// export const Activecouponlist = createAsyncThunk('/activecouponlist', async () => {
//     const response = await ApiHelperFunction({
//         urlPath: 'size/active/size',
//         method: 'GET',
//     });
//     return response;
// });

export const CouponSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        couponlist: builder.mutation({
            query: (data) => ({
                url: 'coupon?' + data,
                method: 'GET',
                credentials: "include",
            }),
        }),
        getCouponslist: builder.query({
            query: (searchData) => ({
                url: `coupon?page=1&limit=100&search=${searchData}`,
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['coupon']
        }),
        Create_Update_Coupon: builder.mutation({
            query: (data) => ({
                method: "POST",
                body: data,
                url: 'coupon',
                credentials: "include",
            }),
            invalidatesTags: ['coupon']
        }),
        GetCouponData: builder.mutation({
            query: (id) => ({
                method: "GET",
                url: 'coupon/' + id,
                credentials: "include",
            }),
            // invalidatesTags:['coupon']
        }),
        Deletecoupon: builder.mutation({
            query: (data) => ({
                method: "DELETE",
                url: 'coupon',
                credentials: "include",
                body: data,
            }),
            invalidatesTags: ['coupon']

        }),
        getActiveCouponslist: builder.mutation({
            query: () => ({
                url: `coupon/valid/Coupon`,
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['coupon']
        }),

    })
});

export const {
    useCouponlistMutation,
    useCreate_Update_CouponMutation,
    useGetCouponDataMutation,
    useDeletecouponMutation,
    useGetCouponslistQuery,
    useGetActiveCouponslistMutation
} = CouponSlice;
